export default "__VITE_ASSET__wRgXXvCu__"